import { TableV2Column } from 'components/Table/TableV2';
import { SearchableSortDirection } from 'generated-graphql/types';
import { useState } from 'react';
import { SortOrder } from 'react-data-table-component';

export type SortInput<TField> = {
  direction: SearchableSortDirection;
  field: TField;
};

type Props<T> = {
  field: T;
  direction: SearchableSortDirection;
};

export const useTableSort = <TField, TColumn>(props: Props<TField>) => {
  const [sort, setSort] = useState<SortInput<TField>>({
    field: props.field,
    direction: props.direction
  });

  const handleSort = (
    selectedColumn: TableV2Column<TColumn>,
    sortDirection: SortOrder
  ) => {
    const sortField = selectedColumn.sortField;
    if (!sortField) return;

    setSort({
      field: sortField as TField,
      direction:
        sortDirection === 'asc'
          ? SearchableSortDirection.Asc
          : SearchableSortDirection.Desc
    });
  };

  return {
    sort,
    handleSort
  };
};
